import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { cartAccountSelector, cartCurrencySelector, cartTotal } from '../redux/selectors/cartSelector';

function useTotal(productId) {
    const [productTotal, setProductTotal] = useState('-');

    const currentAccount = useSelector((state) => cartAccountSelector(state));
    const currency = useSelector((state) => cartCurrencySelector(state));
    const total = useSelector((state) => cartTotal(state, { product_id: productId }));
    const sign = <span dangerouslySetInnerHTML={{ __html: currency?.sign }}></span>;

    useEffect(() => {
        if (total?.total > 0) {
            setProductTotal(
                <>
                    {sign}
                    {Number(total?.total).toFixed(2)}
                </>
            );
        } else {
            setProductTotal('-');
        }
    }, [total?.total, currentAccount]);

    return productTotal;
}

export default useTotal;
